import { z } from 'zod';
import { DEFAULT_ZONE_COLOR } from '@/utils';

export interface Zone {
  id: string;
  name: string;
  color: string;
  geojson: any;
  zoneTypeId: string;
  logisticOperatorId: string;
  active?: boolean;
  createdAt: string;
  updatedAt: string;
  ZoneType?: {
    id: string;
    name: string;
  };
  LogisticOperator?: {
    id: string;
    name: string;
  };
}

export interface NewZone {
  name: string;
  color: string;
  geojson: any;
  zoneTypeId: string;
  logisticOperatorId: string;
}

export interface UpdateZone {
  name?: string;
  color?: string;
  geojson?: any;
  zoneTypeId?: string;
  logisticOperatorId?: string;
  active?: boolean;
}

/** Resultado del DELETE: 'deleted' borra la fila, 'deactivated' es soft delete. */
export type ZoneDeleteResult = 'deleted' | 'deactivated';

export interface ZoneDeleteResponse {
  result: ZoneDeleteResult;
}

export interface ZoneCoverage {
  zoneId: string;
  coverageLogisticOperatorIds: string[];
}

export interface ZoneFilters {
  id?: string;
  name?: string;
  color?: string;
  zoneTypeId?: string;
  logisticOperatorId?: string;
}

export const zoneSchema = z.object({
  name: z
    .string()
    .min(3, 'El nombre debe tener al menos 3 caracteres')
    .max(20, 'El nombre no puede exceder 20 caracteres'),
  color: z
    .string()
    .regex(
      /^#[0-9A-Fa-f]{6}$/,
      'Debe ser un color hexadecimal válido (#RRGGBB)'
    ),
  geojson: z
    .any()
    .refine(
      (data) =>
        data &&
        (data.type === 'Polygon' || data.type === 'MultiPolygon') &&
        Array.isArray(data.coordinates) &&
        data.coordinates.length > 0,
      'Debe proporcionar al menos un polígono válido'
    ),
  zoneTypeId: z.string().min(1, 'Debe seleccionar un tipo de zona'),
  logisticOperatorId: z.string().min(1, 'El Operador Logístico es requerido'),
});

export const updateZoneSchema = zoneSchema.partial().omit({
  logisticOperatorId: true,
});

export type ZoneSchema = z.infer<typeof zoneSchema>;
export type UpdateZoneSchema = z.infer<typeof updateZoneSchema>;

export const defaultZoneValues: ZoneSchema = {
  name: '',
  color: DEFAULT_ZONE_COLOR,
  geojson: {
    type: 'Polygon',
    coordinates: [[]],
  },
  zoneTypeId: '',
  logisticOperatorId: '',
};
